import { type ReactNode } from 'react'
import { useOrg } from '../../contexts/OrgContext'

export interface AuthLayoutProps {
  children: ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  const { name: orgName, branding } = useOrg()

  return (
    <div className="flex min-h-screen flex-col bg-[var(--bg-base)]">
      {/* Header */}
      <header className="flex items-center justify-center p-4 sm:p-6">
        <a href="/" className="flex items-center">
          {branding.logoUrl ? (
            <img
              src={branding.logoUrl}
              alt={orgName || 'Logo'}
              className="h-8 w-auto"
            />
          ) : (
            <span className="text-lg font-semibold text-[var(--text-primary)]">
              {orgName || 'u.software'}
            </span>
          )}
        </a>
      </header>

      {/* Main content */}
      <main className="flex flex-1 items-center justify-center px-4 py-8 sm:px-6 lg:px-8">
        <div className="w-full max-w-md">{children}</div>
      </main>

      {/* Footer */}
      <footer className="powered-by-footer">
        <p>
          Powered by{' '}
          <a href="https://u.software" target="_blank" rel="noopener noreferrer">
            u.software
          </a>
        </p>
      </footer>
    </div>
  )
}
